export default "__VITE_ASSET__vMcrHKxNOSDQ6QJD11tlxA__"